// Items Service - Handles items as Firestore subcollection
// Path: /projects/{projectId}/items/{itemId}

import { collection, doc, onSnapshot, setDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import type { Unsubscribe } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { removeUndefinedValues } from '../utils';
import type { Item } from '../types/core';

const itemDoc = (projectId: string, itemId: number | string) =>
    doc(db, 'projects', projectId.toString(), 'items', itemId.toString());

export const ItemsService = {
    /** Subscribe to real-time items updates for a project. Returns unsubscribe. */
    subscribeToItems(projectId: string, callback: (items: Item[]) => void, onError?: (error: Error) => void): Unsubscribe {
        const q = query(collection(db, 'projects', projectId.toString(), 'items'), orderBy('id', 'asc'));
        return onSnapshot(
            q,
            (snapshot) => callback(snapshot.docs.map(d => ({ ...d.data(), id: parseInt(d.id) || d.data().id }) as Item)),
            (error) => onError?.(error)
        );
    },

    async saveItem(projectId: string, item: Item): Promise<void> {
        await setDoc(itemDoc(projectId, item.id), removeUndefinedValues(item));
    },

    async deleteItem(projectId: string, itemId: number | string): Promise<void> {
        await deleteDoc(itemDoc(projectId, itemId));
    }
};
